import * as Sentry from "@sentry/react";

export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN;

  if (!dsn) {
    console.warn("Sentry DSN not configured. Error tracking is disabled.");
    return;
  }

  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({}),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export interface WarningReport {
  fingerprint: string[];
  tags: Record<string, string>;
  extra: Record<string, unknown>;
}

export function reportWarning(message: string, report: WarningReport): void {
  Sentry.captureMessage(message, { level: "warning", ...report });
}

export function reportError(
  error: unknown,
  tags: Record<string, string>,
): void {
  Sentry.captureException(error, { tags });
}
